/**
 * IconBuilder class for building FontAwesome 6 icon class strings with a fluent interface.
 * Supports method chaining while automatically converting to a string when needed.
 */
export class IconBuilder {
  private classes: string[] = ["fa-sharp", "fa-light"];

  constructor(icon: string) {
    this.classes.push(icon);
  }

  /**
   * Adds border styling classes to the icon
   */
  addBorder(): IconBuilder {
    this.classes.push("border-end", "pe-3");
    return this;
  }

  toString(): string {
    return this.classes.join(" ");
  }

  // Make IconBuilder implicitly convertible to string
  [Symbol.toPrimitive](hint: string): string | null {
    if (hint === 'string' || hint === 'default') {
      return this.toString();
    }
    return null;
  }

  // For older browsers and frameworks
  valueOf(): string {
    return this.toString();
  }
}

/**
 * Creates a FontAwesome 6 icon with a fluent interface.
 * @param icon The FontAwesome 6 icon name (e.g., "fa-save")
 * @returns An IconBuilder instance that can be used with method chaining
 * and automatically converts to a string when needed
 */
export const addFa6Icon = (icon: string): IconBuilder & { toString(): string } => {
  return new IconBuilder(icon);
};